import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import QrCodeCampaignsList from './qr-code-campaigns-list';
import QrCodeCampaignsSearch from './search';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import { getQrCodeCampaigns } from '../../../../actions/qr-code-campaigns';

const EMPTY_FILTERS = {
  campaign_unique_id: '',
  start_date_from: '',
  end_date_to: ''
};

class QrCodeCampaigns extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: { ...EMPTY_FILTERS }
    };
  }

  componentWillMount() {
    this.props.dispatch(getQrCodeCampaigns());
  }

  handleChange = field => (event) => {
    const { value } = event.target;

    this.setState(prevState => ({
      filters: { ...prevState.filters, [field]: value }
    }));
  };

  handleSearch = () => {
    this.props.dispatch(getQrCodeCampaigns(this.state.filters));
  };

  handleClear = () => {
    this.setState({ filters: { ...EMPTY_FILTERS } }, this.handleSearch);
  };

  render() {
    return (
      <Container fluid>
        <PageTitle>
          QR Code Campaigns
        </PageTitle>
        <Link to="/admin/qr_code_campaigns/new">
          <ArrowButton
            arrow={false}
            color="red"
            submit={false}
          >
            Add campaign
          </ArrowButton>
        </Link>

        <QrCodeCampaignsSearch
          filters={this.state.filters}
          onChange={this.handleChange}
          onClear={this.handleClear}
          onSearch={this.handleSearch}
        />

        <QrCodeCampaignsList
          campaigns={this.props.campaigns}
          fetched={this.props.fetched}
          fetching={this.props.fetching}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  campaigns: state.qrCodeCampaigns.campaigns,
  fetched: state.qrCodeCampaigns.fetched,
  fetching: state.qrCodeCampaigns.fetching
});

export default connect(mapStateToProps)(QrCodeCampaigns);
